module.exports = __webpack_public_path__ + "img/img15.83147a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img15.jpg
// module id = 311
// module chunks = 0